/**
 * DUNAMIS WEAR — Catálogo Masculino / Feminino
 */
(function () {
  'use strict';

  document.querySelectorAll('.gender-catalog__tabs').forEach(function (tablist) {
    var section = tablist.closest('.gender-catalog');
    if (!section) return;

    var tabs = tablist.querySelectorAll('[data-gender-tab]');
    var panels = section.querySelectorAll('[data-gender-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-gender-tab');

        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-gender-panel') === target;
          panel.classList.toggle('is-active', active);
          if (active) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      });
    });
  });

  /* Home: swipe lateral no card para revelar a frente (capa já é as costas) */
  document.querySelectorAll('[data-catalog-flip]').forEach(function (card) {
    var media = card.querySelector('[data-catalog-flip-media]');
    if (!media) return;

    var startX = 0;
    var startY = 0;
    var tracking = false;
    var swiped = false;

    media.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches || !e.touches[0]) return;
        tracking = true;
        swiped = false;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      },
      { passive: true }
    );

    media.addEventListener(
      'touchmove',
      function (e) {
        if (!tracking || !e.touches || !e.touches[0]) return;
        var dx = e.touches[0].clientX - startX;
        var dy = e.touches[0].clientY - startY;
        if (Math.abs(dx) > 28 && Math.abs(dx) > Math.abs(dy) * 1.15) {
          swiped = true;
          if (dx < 0) {
            card.classList.add('is-showing-back');
          } else {
            card.classList.remove('is-showing-back');
          }
        }
      },
      { passive: true }
    );

    media.addEventListener(
      'touchend',
      function () {
        tracking = false;
      },
      { passive: true }
    );

    /* Evita abrir o link se o gesto foi um swipe */
    var link = card.querySelector('.catalog-card__summary-link');
    if (link) {
      link.addEventListener('click', function (e) {
        if (swiped) {
          e.preventDefault();
          swiped = false;
        }
      });
    }
  });
})();
